import ServiceLocator from 'live/services/service-locator'
import RigDashboards from './RigDashboards'

function testRedirect() {
    const h = window.location.hash
    const isRootHash = h.startsWith('#/rig') && h.endsWith('dashboards')

    if (isRootHash) window.location = window.location.hash.replace("dashboards","navigation")
}

try {
    window.addEventListener('hashchange', testRedirect)
        testRedirect()

    ServiceLocator.getService('asset-tab-service').then(service => {
        service.register({
            step: 'navigation',
            order: 1,
            assetType: 'rig',
            label: 'Dashboards',
            shouldHide: false,
            body: RigDashboards
        })
    })
} catch (e) {
    console.error(e)
}